import { signal } from '@angular/core';
import { FieldTree, SchemaPathTree } from '@angular/forms/signals';
import { SingleCoreArrangementDto } from '../../../../core/mceapi.client.generated';
import { apiOpt, appOpt } from '../../../../core/mceapi.client.helpers';
import { match, none, Option, some } from '../../../../shared/functions/functional';
import { buildSpacingSchema, createSpacing, createSpacingDto, defaultSpacing, Spacing } from '../spacing/spacing.model';
import { VoltageCase } from '../../system-voltage/system-voltage.model';


export enum SCA {
  DC = "DC",
  AC1ph = "AC1ph",
  AC3phTrefoil = "AC3phTrefoil",
  AC3phFlat = "AC3phFlat",
}

export type SingleCoreArrangementCase = SCA | '';

// Build appropriate cases.  All except trefoil will require spacing to be specified.
export function singleCoreCases(voltageCase:VoltageCase) {

  switch (voltageCase) {

    case VoltageCase.DC: return [{ value: SCA.DC, label: "DC" }];

    case VoltageCase.AC1ph: return [{ value: SCA.AC1ph, label: "AC1ph" }];

    case VoltageCase.AC3ph:
    case VoltageCase.TPN:
      return [
          { value: SCA.AC3phFlat, label: "AC3ph Flat" },
          { value: SCA.AC3phTrefoil, label: "AC3ph Trefoil" }
        ]
  }
}

export interface SingleCoreArrangement {
  required: boolean;
  case: SingleCoreArrangementCase,
  spacing: Spacing;
}

export function buildSingleCoreArrangementSchema(path: SchemaPathTree<SingleCoreArrangement>) {
  buildSpacingSchema(path.spacing);
}

export function createSingleCoreArrangement(dto: Option<SingleCoreArrangementDto>) {
  return signal<SingleCoreArrangement>(
    match(
      (): SingleCoreArrangement => ({
        required: false,
        case: '',
        spacing: defaultSpacing()
      }),
      (x: SingleCoreArrangementDto): SingleCoreArrangement => {
        if (x.case === undefined) {
          throw new Error('Single-core arrangement DTO is missing its case.');
        }

        return {
          required: true,
          case: x.case as SingleCoreArrangementCase,
          spacing: createSpacing(appOpt(x.spacing ?? {}))()
        };
      })(dto));
}

export function createSingleCoreArrangementDto(model: FieldTree<SingleCoreArrangement>) {
    return signal<Option<SingleCoreArrangementDto>>(
      model.required().value()
        ? some({
          case: model.case().value(),
          spacing: apiOpt(createSpacingDto(model.spacing)())
        } as SingleCoreArrangementDto)
        : none);
}
